<template lang="pug">
	.fondoTransparente(v-if="activo", @click="cerrar")
		.contextual(:style="menu.style")
			div.titulo.bg-info.text-white(v-if="menu.titulo") {{ menu.titulo }}
			div.contieneItems
				div.p-2(v-for="item in menu.items", :key="item.texto", @click="clickItem(item)", style="cursor:default;", :class="(!item.activo) ? 'disabled' : 'active'")
					span(v-if="item.icono", :class="item.icono", class="mr-2")
					| {{item.texto}}
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters({
			menu: 'contextual/menu',
			activo: 'contextual/activo'
		})
	},
	created () {
		this.$store.watch(
			(a) => a.contextual.activo,
			(newValue, oldValue) => {
				console.log('Cambia a: ' + newValue)
			})
	},
	methods: {
		clickItem (item) {
			if (!item.activo) {
				this.cerrar()
				return
			}
			item.callback()
			this.cerrar()
		},
		cerrar () {
			this.$store.commit('contextual/cerrar')
		}
	}
}
</script>

<style scoped>
	.fondoTransparente {
		position: fixed;
		display: block;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		overflow: hidden;
		z-index: 2005;
	}
	.contextual {
		position: fixed;
		display: block;
		border: 1px solid #e0e0e0;
		background-color: white;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
		min-width: 200px;
		text-align: left;
		z-index: 2006;
	}
	.contextual > .titulo {
		padding: 3px;
		position: relative;
		display: block;
		text-align: center;
	}

	.contextual > .contieneItems {
		position: relative;
		display: block;
	}

	.contextual > .contieneItems > div {
		position: relative;
		display: block;
	}

	.contextual > .contieneItems > div.active:hover {
		background-color: #333333;
		color: white;
	}

	.contextual > .contieneItems > div.disabled {
		color: #e0e0e0;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/contextual/contextual.vue